import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService, DialogService } from '@pos-app/core-ui';
import { HelpComponentDetails, HelpComponentRoles, ProgrammeArray } from '@pos-app/data';
import { ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-community';
import { ManageCentralAllHelpComponentRender } from '@pos-app/core-ui/lib/components/manage-central-component/manage-central-component-render';
import { ToastrService } from 'ngx-toastr';
import { Subject, BehaviorSubject } from 'rxjs';
import { CoreUiModule } from '../../../../../../../../libs/core-ui/src/lib/core-ui.module';
import { FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';

@Component({
    selector: 'app-manage-help-component',
    templateUrl: './manage-help-component.component.html',
    styleUrls: ['./manage-help-component.component.scss'],
    imports: [CoreUiModule, FormsModule, AgGridModule, AsyncPipe]
})
export class ManageHelpComponent implements OnInit {
  @ViewChild('content') content: ElementRef;
  private _loading$ = new BehaviorSubject<boolean>(false);
  loading$ = this._loading$.asObservable();
  rowData = [];
  searchValue: string;
  gridOptions: GridOptions;
  columnDefs: ColDef[];
  frameworkComponents;
  context;
  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  expanded: boolean = false;
  isEditMode: boolean = false;
  isCreateNew: boolean = false;
  helpComponentDetails: HelpComponentDetails;
  helpComponentDetails_id: string;
  helpComponentRoles: HelpComponentRoles[] = [];

  constructor(private apiService: ApiService, private modalService: NgbModal, private toastr: ToastrService, private dialougeService: DialogService) {
    this.frameworkComponents = {
      actionRenderer: ManageCentralAllHelpComponentRender,
    };
    this.context = { componentParent: this };
    this.gridOptions = this.gridOptionsData();
  }

  ngOnInit() {
    // Initialization

    if (this.helpComponentRoles.length == 0) {
      this.apiService.fetchHelpComponentRoles().subscribe((data) => {
        this.helpComponentRoles = data?.SearchResults || [];
      });
    }
    this.loadHelpComponents();
  }

  private loadHelpComponents() {
    this._loading$.next(true);
    this.apiService.fetchAllHelpComponents().subscribe((components) => {
      this._loading$.next(false);
      this.rowData = components?.helpComponents || [];
      this.gridApi?.setRowData(this.rowData);
      this.gridApi?.paginationGoToPage(0);
    });
  }

  gridOptionsData() {
    return {
      defaultColDef: {
        resizable: true,
        sortable: true,
        width: 150,
        cellClass: 'cell-class ag-right-aligned-cell',
        headerClass: 'header-class ag-left-aligned-header',
      },
      columnDefs: [
        {
          headerName: 'ACTION',
          width: 100,
          cellRenderer: 'actionRenderer',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'TILES',
          width: 160,
          field: 'tileArray',
          cellStyle: { 'text-align': 'left' },
          cellRenderer: (params) => {
            if (params.data?.tileArray && params.data.tileArray.length > 0) {
              // Added inline style for small height
              return `<a href="javascript:void(0)" class="ag-expand-link" style="height:22px; padding:0 8px; line-height:1; display:inline-block;">Show Details</a>`;
            }
            return '';
          },
          onCellClicked: (params) => {
            if (!params.node.expanded) {
              params.node.setExpanded(true);
              const linkElement = params.event.target as HTMLElement;
              //change to a href tag
              linkElement.innerHTML = '<a href="javascript:void(0)" class="ag-expand-link">Hide Details</a>';
            } else {
              params.node.setExpanded(false);
              const linkElement = params.event.target as HTMLElement;
              linkElement.innerHTML = '<a href="javascript:void(0)" class="ag-expand-link">Show Details</a>';
            }
          },
        },

        {
          headerName: 'USER ROLE',
          width: 150,
          field: 'userRole',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'PROGRAMME CODE',
          width: 190,
          field: 'programmeCode',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'CUSTOMER CATEGORY',
          width: 150,
          field: 'customerCategory',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'HEADER TEXT',
          field: 'headerText',
          flex: 1,
          minWidth: 200,
          cellStyle: { 'text-align': 'left', 'text-transform': 'none', 'white-space': 'normal', 'word-wrap': 'break-word' },
          onCellClicked: (params) => {
            this.expanded = !this.expanded;
            this.getNewWidth(params, this.expanded);
          },
          valueGetter: (params) => {
            // Remove HTML tags from headerText
            const text = params.data?.headerText || '';
            return text.replace(/<[^>]*>/g, '');
          },
        },
        {
          headerName: 'HEADER ICON',
          width: 150,
          field: 'headerPictureURL',
          cellStyle: { 'text-align': 'left' },
        },
      ],
      masterDetail: true,
      detailCellRendererParams: {
        detailGridOptions: {
          columnDefs: [
            { headerName: 'Name', field: 'label', width: 150 },
            { headerName: 'URL', field: 'url', width: 250 },
            { headerName: 'Icon', field: 'icon', width: 150 },
            { headerName: 'Load in New Tab', field: 'loadInNewTab', width: 250 },
            // Add more columns as needed based on tileArray structure
          ],
          defaultColDef: {
            flex: 1,
            minWidth: 100,
            resizable: true,
          },
        },
        getDetailRowData: (params) => {
          params.successCallback(params.data.tileArray || []);
        },
      },
      isRowMaster: (dataItem) => {
        return dataItem && Array.isArray(dataItem.tileArray) && dataItem.tileArray.length > 0;
      },
      onGridReady: (params) => {
        params.columnApi.applyColumnState({
          state: [{ colId: 'requestedDate', sort: 'asc' }],
          applyOrder: true,
        });
      },
    };
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    const sortModel = [{ colId: 'dateTime', sort: 'desc' }];
  }

  getNewWidth(params, expand): void {
    let text = params.data?.headerText || '';
    text = text.replace(/<[^>]*>/g, '');
    const textLength = (text.length || 0) * 10;
    const minWidth = params.colDef.minWidth || params.colDef.width;
    if (textLength > minWidth && expand) {
      this.expanded = true;
      return params.columnApi.setColumnWidth(params.column, textLength + 50);
    } else {
      return params.columnApi.setColumnWidth(params.column, text.length > minWidth ? text.length : minWidth);
    }
  }

  showHelpComponenetDetail(data) {
    //this.safeHtmlBody = this.customUrlSchemeHandler.handleUrl(this.userSeletedEmailDetailsData.body, this.userSeletedEmailDetailsData.attachments);
    //removing tailing spaces

    //this.safeHtmlBody = this.sanitizer.bypassSecurityTrustHtml(this.safeHtmlBody.toString());
    this.helpComponentDetails = data;
    this.modalService.open(this.content, {
      windowClass: 'modal-holder',
      size: 'xl',
      backdrop: 'static',
    });
  }

  editHelpComponenetDetail(data) {
    this.isEditMode = true;
    this.isCreateNew = false;
    this.helpComponentDetails_id = data._id; // Store the ID for updates
    this.showHelpComponenetDetail(data);
  }

  closeModal() {
    this.modalService.dismissAll();
  }
  onCreateNew() {
    this.isCreateNew = true;
    this.isEditMode = false;
    this.helpComponentDetails = null; // Reset details for new creation
    this.modalService.open(this.content, {
      windowClass: 'modal-holder',
      size: 'xl',
      backdrop: 'static',
    });
  }

  saveAdd(data) {
    this._loading$.next(true);
    if (this.isCreateNew) {
      this.apiService.addHelpComponent(data).subscribe((data) => {
        if (data?.ErrorFlag === '0') {
          this.closeModal();
          this.toastr.success('Help component added successfully');
          this.loadHelpComponents(); // Reload the list after addition
          this._loading$.next(false);
        } else {
          this._loading$.next(false);
          this.toastr.error('Failed to add help component');
        }
      });
    } else if (this.isEditMode) {
      // Compare object value with this.helpComponentDetails and update only changed values
      // const updatedData = {};
      // for (const key in data) {
      //   if (data.hasOwnProperty(key) && data[key] !== this.helpComponentDetails[key]) {
      //     updatedData[key] = data[key];
      //   }
      // }

      let dataWithId = { ...data, _id: this.helpComponentDetails_id }; // Include ID for update
      this.apiService.updateHelpComponent(dataWithId).subscribe((data) => {
        if (data?.ErrorFlag === '0') {
          this.closeModal();
          this.toastr.success('Help component updated successfully');
          this.loadHelpComponents(); // Reload the list after update
        } else {
          this._loading$.next(false);
          this.toastr.error('Failed to update help component');
        }
      });
    }
  }

  deleteHelpComponenetDetail(helpComponentDetails) {
    this.dialougeService.confirm('Are you sure you want to delete this help component?').subscribe((result) => {
        if (result) {
        this._loading$.next(true);
        this.apiService.removeHelpComponent(helpComponentDetails._id).subscribe((data) => {
          if (data?.ErrorFlag === '0') {
            this.toastr.success('Help component deleted successfully');
            this.loadHelpComponents(); // Reload the list after deletion
            this._loading$.next(false);
          } else {
            this._loading$.next(false);
            this.toastr.error('Failed to delete help component');
          }
        });
      }
    });
  }
}

